// Modal.js
import React from "react";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center overflow-y-auto z-50">
      <div className="bg-white p-12 rounded-lg shadow-2xl border-2 border-gray-300 w-full max-w-6xl overflow-y-auto z-60">
        <h2 className="font-bold">Graphical Overview</h2>
        <button className="float-right text-lg font-bold" onClick={onClose}>
          Close
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
